import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import { getOne } from '@/shared/api/http';

import { isPlatformReadiness } from '../model/types';
import type { PlatformReadiness } from '../model/types';

export const READINESS_URL = '/readiness';

/* No X-Lumiq-Tenant header, here or anywhere in this client. Hard rule 1: only the edge sets it,
 * from a validated token claim. A frontend that sends it is asking the backend to trust the
 * browser, which is the whole vulnerability. */
async function fetchReadiness(): Promise<PlatformReadiness> {
  /* `/readiness` is a public route (`RouteClass.PUBLIC`, `authenticated=False`), so the token this
   * attaches is surplus rather than required — routed through the shared transport anyway so that
   * one file decides what a request to this platform carries. */
  return getOne(READINESS_URL, isPlatformReadiness, 'readiness');
}

export function useReadiness(): UseQueryResult<PlatformReadiness> {
  return useQuery({
    queryKey: ['platform', 'readiness'],
    queryFn: fetchReadiness,
    /* Polled, because a capability can come up without a page reload — and an operator watching
     * this screen during a deployment is exactly the audience. */
    refetchInterval: 10_000,
    retry: false,
  });
}
